// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pdfviewer{height:100%}@media(min-width: 641){#pdfviewer{max-width:calc(100vw - 12rem)}}", "",{"version":3,"sources":["webpack://../styles.scss"],"names":[],"mappings":"AAEA,WACG,WAAA,CAEA,uBAHH,WAIM,6BAAA,CAAA","sourcesContent":["@import '../../scss/functions';\n\n#pdfviewer {\n   height: 100%;\n\n   @media (min-width: 641) {\n      max-width: calc(100vw - 12rem);\n   }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
